import { render, staticRenderFns } from "./XGridPop.vue?vue&type=template&id=3529ff08&scoped=true&"
import script from "./XGridPop.vue?vue&type=script&lang=js&"
export * from "./XGridPop.vue?vue&type=script&lang=js&"
import style0 from "./XGridPop.vue?vue&type=style&index=0&id=3529ff08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3529ff08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3529ff08')) {
      api.createRecord('3529ff08', component.options)
    } else {
      api.reload('3529ff08', component.options)
    }
    module.hot.accept("./XGridPop.vue?vue&type=template&id=3529ff08&scoped=true&", function () {
      api.rerender('3529ff08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grid/XGridPop.vue"
export default component.exports